import LogoutLogo from '@assets/images/ambassdor/dashboard/log-out.svg'
import { NEW_PROGRAM_PROFILE, PROFILE_TABS } from './enum'
import student_image from '@assets/images/ambassdor/OnboardingFlow/student.webp'
import business_image from '@assets/images/ambassdor/OnboardingFlow/business.webp'
import professional_image from '@assets/images/ambassdor/OnboardingFlow/professional.webp'
import school_image from '@assets/images/ambassdor/OnboardingFlow/school.webp'
import college_image from '@assets/images/ambassdor/OnboardingFlow/college.webp'

import medical_image from '@assets/images/ambassdor/OnboardingFlow/medical.webp'
import engineering_image from '@assets/images/ambassdor/OnboardingFlow/engineering.webp'
import other_fields_image from '@assets/images/ambassdor/OnboardingFlow/otherFields.webp'

import postgraduate_image from '@assets/images/ambassdor/OnboardingFlow/postgraduate.webp'
import advan_medical_image from '@assets/images/ambassdor/OnboardingFlow/advanMedical.webp'
import other_courses_image from '@assets/images/ambassdor/OnboardingFlow/otherCourses.webp'
import shop_business_image from '@assets/images/ambassdor/OnboardingFlow/shopBusiness.webp'
import diff_business_image from '@assets/images/ambassdor/OnboardingFlow/diffBusiness.webp'
import calendarImg from '@assets/images/calendar.png'
import phoneImg from '@assets/images/phoneIcon.png'

import { saathiTypeList } from './constants'
import { ProfileMapping, SublayersMapping } from './types'
import { CommissionConfig } from '@api/hooks/ambassdor/useGetAvgCommissions'

export const items = [
  { name: 'Last 30 Days', key: 'Last 30 Days' },
  { name: 'Last Months', key: 'Last Months' },
  { name: 'Last Year', key: 'Last Year' },
  { name: 'Current Year', key: 'Current Year' },
  { name: 'Last Week', key: 'Last Week' },
  { name: 'Last 7 days', key: 'Last 7 days' },
  { name: 'Today', key: 'Today' },
  { name: 'Yesterday', key: 'Yesterday' },
  { name: 'Custom Calender', key: 'Custom Calender' },
]

export const filteritems = [
  'Last 30 Days',
  'Last Months',
  'Last Year',
  'Current Year',
  'Last Week',
  'Last 7 days',
  'Today',
  'Yesterday',
  'Custom Calender',
]

export const paymentWrapperItems = [
  { name: 'Pending', key: 'Pending' },
  { name: 'Successful', key: 'Successful' },
  { name: 'Failed', key: 'Failed' },
]

export const ProfileDropDownItems = [
  {
    name: 'Logout',
    key: 'Logout',
    icon: `${LogoutLogo}`,
    hoverColor: '#009898',
  },
]
export const LANDING_PAGE = {
  CONTACT: 'CONTACT',
  EARN: 'EARN',
  FAQ: 'FAQ',
  TESTIMONIAL: 'TESTIMONIAL',
  STEPS: 'STEPS',
  PRESENCE: 'PRESENCE',
  HOW_IT_WORKS: 'HOW_IT_WORKS',
}

export const landingPageHeaderItems = [
  {
    name: 'Earning Calculator',
    type: LANDING_PAGE.EARN,
  },
  {
    name: 'Testimonials',
    type: LANDING_PAGE.TESTIMONIAL,
  },
  {
    name: 'FAQ',
    type: LANDING_PAGE.FAQ,
  },
]

export const IntroductData = [
  { id: 1, title: 'Introduction to PW Ambassador' },
  { id: 2, title: 'Introduction to PW Ambassador' },
  { id: 3, title: 'Introduction to PW Ambassador' },
  { id: 4, title: 'Introduction to PW Ambassador' },
  { id: 5, title: 'Introduction to PW Ambassador' },
  { id: 6, title: 'Introduction to PW Ambassador' },
]

export const optionsForFilterDropdown: any = {
  mode: 'range',
  inline: true,
  monthSelectorType: 'static',
  dateFormat: 'M j, Y',
  prevArrow:
    '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
  nextArrow:
    '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>',
  minDate: new Date('01-01-2000'),
  maxDate: new Date(),
}

export const PROFILE_HEADER = [
  {
    name: 'Personal Details',
    key: PROFILE_TABS.PERSONAL,
  },
  {
    name: 'Program Details',
    key: PROFILE_TABS.PROGRAM,
  },
  {
    name: 'Payment Details',
    key: PROFILE_TABS.PAYMENT,
  },
]

export const btnType = [
  {
    type: 'Submit',
  },
]

export const PAYMENT_STATUS_MSG = {
  headingOne: 'Payment Details',
  headingTwo: 'Payment Details Updated',
  titleOne: 'Update your payment details to generate a coupon',
  titleTwo: 'You will receive payments in your submitted bank account',
  titleForSaathi: 'Update your payment details to start uploading leads',
}

export const EMAIL_STATUS_MSG = {
  verifyEmail: 'Verify your email address',
  emailVerified: 'Email Address Verified',
  brifMsg: 'Update your email to receive notifications.',
}

export const NOTIFICATION_DATA = {
  titleOne: 'Your profile is currently under review',
  infoOne: `Until your application is approved, you won’t be able to generate a coupon.`,
  titleTwo: 'Your application is approved!',
  infoTwo: `You can now start earning by sharing offers and helping students purchase courses.`,
  infoSaathiApprove: `You can start uploading leads to earn commission.`,
  titleSaathiNotAppr: `Your Profile is currently under review.`,
  infoSaathiNotAppr: `Until your application is approved, you won’t be able to upload leads.`,
  titleCertificate: 'Your certificate is ready for download!',
  infoCertificate: 'Download & share to celebrate your valuable partnership with PW!',
}
export const descriptionTypes = [
  {
    title: `I'm a student`,
    refers: '',
    type: 'student',
    image: `${student_image}`,
  },
  {
    title: `I'm a business owner`,
    refers: '',
    type: 'business',
    image: `${business_image}`,
  },
  {
    title: `I'm a working professional`,
    refers: '(Educator, Blogger, etc.)',
    type: 'professional',
    image: `${professional_image}`,
  },
]

export const studentDetails = [
  {
    title: `I'm in school`,
    refers: '',
    type: 'school',
    image: `${school_image}`,
  },
  {
    title: `I'm in college`,
    refers: '',
    type: 'college',
    image: `${college_image}`,
  },
]

export const collegeDetails = [
  {
    title: `Medical`,
    refers: `(MBBS, MD/MS)`,
    type: 'medical',
    image: `${medical_image}`,
  },
  {
    title: `Engineering`,
    refers: '',
    type: 'engineering',
    image: `${engineering_image}`,
  },
  {
    title: `Other Fields`,
    refers: `(Law, Arts, Commerce,etc)`,
    type: 'otherFields',
    image: `${other_fields_image}`,
  },
]

export const medicalDetails = [
  {
    title: `Undergraduate`,
    refers: '',
    type: 'undergraduate',
    image: `${college_image}`,
  },
  {
    title: `Postgraduate`,
    refers: '',
    type: 'postgraduate',
    image: `${postgraduate_image}`,
  },
]

export const undergraduateDetails = [
  {
    title: `Advanced Medical Courses`,
    refers: `(NEET-PG)`,
    type: 'advan_medical',
    image: `${advan_medical_image}`,
  },
  {
    title: `Other courses`,
    refers: `(IIT, NEET-UG, UPSC, GATE, MBA)`,
    type: 'other_courses',
    image: `${other_courses_image}`,
  },
]

export const businessDetails = [
  {
    title: `Yes, I own a physical shop`,
    refers: '',
    type: 'shop_business',
    image: `${shop_business_image}`,
  },
  {
    title: `No, I run a different business `,
    refers: `(services, online, consulting, etc.)`,
    type: 'diff_business',
    image: `${diff_business_image}`,
  },
]

export const headlingTitle = (sublayers: string) => {
  switch (sublayers) {
    case NEW_PROGRAM_PROFILE.STUDENT:
      return {
        headingTitle: ` Are you currently studying in school or college?`,
      }
    case NEW_PROGRAM_PROFILE.COLLEGE:
      return {
        headingTitle: `What type of course are you currently studying?`,
        subTitle: `Pick the one that best describes your field of study or future goals`,
      }
    case NEW_PROGRAM_PROFILE.MEDICAL:
      return {
        headingTitle: `Which stage of your medical studies are you in?`,
      }
    case NEW_PROGRAM_PROFILE.UNDER_GRADUATE:
      return {
        headingTitle: `Which types of courses would you prefer to promote?`,
      }
    case NEW_PROGRAM_PROFILE.BUSINESS:
      return { headingTitle: `Do you own a physical shop or store?` }

    default:
      return { headingTitle: `What best describes you right now?` }
  }
}

export const YOURSELF_DATA = {
  title: `You’re All Set!`,
  description: `You’re just one step away from completing your application!`,
  btnName: `Continue`,
}

export const YOURSELF_DETAILS = {
  title: 'Tell Us About Yourself',
  description: `Answer a few questions to help us match you with the ideal program for
        your goals`,
  btnName: `Let's Go!`,
}

export const infoBatchDataSet = [
  {
    title: 'Online',
    info: 'All PW online courses including our bestselling IIT JEE & NEET courses at affordable prices',
  },
  {
    newTag: 'new',
    title: 'Power Batch',
    info: 'Premium online courses for competitive exam coaching with dedicated mentors and unlimited doubt solving',
  },
  {
    newTag: 'new',
    title: 'Offline',
    info: 'Expert-guided teaching with comprehensive resources at Vidyapeeth & Pathshala centres all over India',
  },
]

export const empCategory = (empCategory: string) => {
  if (empCategory === saathiTypeList[0]?.value) {
    return `Coaching institute name or write ‘Independent’ if self-employed`
  } else if (empCategory === saathiTypeList[1]?.value) {
    return 'Enter your School Name'
  } else if (empCategory === saathiTypeList[2]?.value) {
    return 'Enter the name of your Counselling Organisation or Institute'
  } else if (empCategory === saathiTypeList[3]?.value) {
    return `Organisation name or write ‘Independent’ if self-employed`
  } else {
    return ''
  }
}

export const filterLeadList = [
  'Last 30 Days',
  'Last Months',
  'Last 7 days',
  'Last Week',
  'Today',
  'Yesterday',
  '',
]

export const dataMap: Record<string, any> = {
  [NEW_PROGRAM_PROFILE.STUDENT]: studentDetails,
  [NEW_PROGRAM_PROFILE.BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.COLLEGE]: collegeDetails,
  [NEW_PROGRAM_PROFILE.MEDICAL]: medicalDetails,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: undergraduateDetails,
}

export const profileMapping: ProfileMapping = {
  [NEW_PROGRAM_PROFILE.STUDENT]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.BUSINESS]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.PROFESSIONAL]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.SCHOOL]: studentDetails,
  [NEW_PROGRAM_PROFILE.COLLEGE]: studentDetails,
  [NEW_PROGRAM_PROFILE.MEDICAL]: collegeDetails,
  [NEW_PROGRAM_PROFILE.ENGINEERING]: collegeDetails,
  [NEW_PROGRAM_PROFILE.OTHER_FIELDS]: collegeDetails,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: medicalDetails,
  [NEW_PROGRAM_PROFILE.POST_GRADUATE]: medicalDetails,
  [NEW_PROGRAM_PROFILE.SHOP_BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.DIFF_BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.ADVAN_MEDICAL]: undergraduateDetails,
  [NEW_PROGRAM_PROFILE.OTHER_COURSES]: undergraduateDetails,
  [NEW_PROGRAM_PROFILE.DEFAULT_DATA]: descriptionTypes,
}

export const newSublayersMapping: SublayersMapping = {
  [NEW_PROGRAM_PROFILE.STUDENT]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.PROFESSIONAL]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.SCHOOL]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.COLLEGE]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.MEDICAL]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.ENGINEERING]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.OTHER_FIELDS]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: NEW_PROGRAM_PROFILE.MEDICAL,
  [NEW_PROGRAM_PROFILE.POST_GRADUATE]: NEW_PROGRAM_PROFILE.MEDICAL,
  [NEW_PROGRAM_PROFILE.SHOP_BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.DIFF_BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.ADVAN_MEDICAL]: NEW_PROGRAM_PROFILE.UNDER_GRADUATE,
  [NEW_PROGRAM_PROFILE.OTHER_COURSES]: NEW_PROGRAM_PROFILE.UNDER_GRADUATE,
  [NEW_PROGRAM_PROFILE.DEFAULT_DATA]: NEW_PROGRAM_PROFILE.DEFAULT_DATA,
}

export const COMMISSION_VIEW_ORGANIZATIONAl_DATA = [
  {
    orgName: 'Assist & Earn',
    orgId: '3',
    allowForCampusMeded: false,
    orgfeatType: 'ASSISTED_SALES',
  },
  {
    orgName: 'Personalised Coupon',
    orgId: '6',
    allowForCampusMeded: false,
    orgfeatType: 'PERSONALISED_COUPON',
  },
  { orgName: 'Normal Coupon', orgId: '1', allowForCampusMeded: true, orgfeatType: 'AMBASSADOR' },
  {
    orgName: 'Sign-up',
    orgId: '5',
    allowForCampusMeded: false,
    orgfeatType: 'AMBASSADOR_SIGN_UP',
  },
]

export const COMMISSION_CALCULATION_DATA = [
  {
    title: 'Phone Number Verification',
    info: 'The mobile number used for course registration must match the number provided in lead',
    image: `${phoneImg}`
  },
  {
    title: 'Lead Conversion Timeframe',
    info: 'Course registration must be completed within 30 days of lead submission',
    image: `${calendarImg}`
  }
]

export const landingPageHeaderItemsCSC = [
  {
    name: 'Steps',
    type: LANDING_PAGE.STEPS,
  },
  {
    name: 'Our Presence',
    type: LANDING_PAGE.PRESENCE,
  },
  {
    name: 'How it Works',
    type: LANDING_PAGE.HOW_IT_WORKS,
  },
  {
    name: 'FAQ',
    type: LANDING_PAGE.FAQ,
  },
]
export const HAMBURGER_CSC = [
  { name: 'Steps', key: 'Steps' },
  { name: 'Our Presence', key: 'Presence' },
  { name: 'How it Works', key: 'how_it_works' },
  { name: 'FAQ', key: 'faq' },

]

export const EarnTypesDetails = (avgCommission: CommissionConfig) => {
  return [
    {
      title: 'Assist & Earn',
      infoIcon: true,
      tag: false,
      para1: `Sell the batch <span class='font-bold'>right now</span> and earn a <span class='font-bold'>higher commission</span>`,
      para2: `You earn upto <span class='font-bold'>${avgCommission?.avgNewStudentCommissionPerc != 0 ? avgCommission?.avgNewStudentCommissionPerc : 8}%</span> on every sale`,
      para3: `Upto <span class='font-bold'>₹ ${avgCommission?.avgNewStudentCeiling != 0 ? avgCommission?.avgNewStudentCeiling : 1000}</span> per sale`,
      ctaName: `Sell Now & Earn`,
      directionLink: `/cohort-selection`,
      imageLink: `https://static.pw.live/5eb393ee95fab7468a79d189/Admin/3bff32d4-3fb2-4506-b975-8640ae5901b1.png`,
      allowForCampusMeded: true,
    },
    {
      title: 'Send Offer & Earn',
      infoIcon: false,
      tag: true,
      para1: `Not ready to buy now?`,
      para2: `Send a <span class='font-bold'>personal offer</span>`,
      para3: `You earn when the student purchases`,
      ctaName: `Share Offer`,
      directionLink: `/dashboard/special-link`,
      imageLink: `https://static.pw.live/5eb393ee95fab7468a79d189/Admin/c566c69b-9060-4558-a7f3-31b238d90179.png`,
      allowForCampusMeded: false,
    },
  ]
}

export const EarnTypesDetailsCSC = (avgCommission: CommissionConfig) => {
  return [
    {
      title: 'Assisted Sale',
      infoIcon: true,
      tag: true,
      para1: `Guide students instantly through the batch selection and checkout process.`,
      para2: 'Discounts are auto-applied, and you earn a special commission on every successful sale!',
      para3: '',
      ctaName: `Sell Now & Earn`,
      directionLink: `/cohort-selection`,
      imageLink: `https://static.pw.live/5eb393ee95fab7468a79d189/Admin/3bff32d4-3fb2-4506-b975-8640ae5901b1.png`,
      allowForCampusMeded: true,
    },
  ]
}

export const cohortIdList = [
  '634ff38121afb100182752f0', '671a1d7c55372e67d74b943d', '66fca713f471f827a15860b5', '66fcad1c51d5941e7572392e', '671f6358b803835fc481b3e5', '67566ffe023fc5a1315eecb3', '6756924413b6acf0774d59d7', '67208f2725ce9f71b8452909', '672b0b91a4fd55cf23eca1ac', '67208f6cee1772d7f80be4bc', '67208f3ec5ced55292825d86', '67566ed509f4226f697da4fb',

  '634fd507a377bf00129fd303', '671c9593fe94f8ad03fe5d29', '66fcaf2a048445fc2979ad9a', '66fcb065c48195ff9dc6ef3a', '698cc4bbcf935cc79424e324', '6912de17931b08f7039a503b', '67e3ab8d1f8a847c89528f9c', '698cc33749d3706b8b44381e',

  '6643a9c8c7215200187c365e', '671ca310e41445c2c92510ff', '6705f63bbf091a47b0b7217e', '6705f6f5813532d4bdaa5d0e', '69089771dc72e22bcf4bbc30', '6908989cbac2a251315cbbf2', '692812a66a15fe1940c2261f', '69492d82c3322213e9307199', '69089b650972ec4c6548c550',

  '634fe256775acd0011e3863d', '671b4c688ae9f67cc6d397ad', '66fc98081e2bd755e19abdb2', '66fca486ddd68106200e9672', '68493d3eba136a96fdacacf6', '677e6bc9b6e6f3dd71e139ec', '67569268467054f6c8f188e5', '68493f7b25931d10e8318a63', '675fdc26089cf02d99a035b2', '680b550a1f252663d880288a', '680b51d918540c76343a6000', '67545423e6b841e4034eac6a',

  '6605106bc773bd0018e27582', '671c9069e0f7b605c51caf66', '6705f2f1a590b7b25d0b3b80', '6705f221813532d4bdaa2189', '685b76a62da8177cf25cc018', '6864dbd310f35a318c40b374', '6865054ec95bab3833a828f6', '67209109647d4d24a89503c6', '685b76a657f2aae98de9fd2b', '698b3e93518ff8691b6be126',

  '6643a6f4babd5b001831cde2', '671ca077ff7678ec629d6d64', '6705f3b0de3ee1e1899a5e98', '6705f4d5b91655f7dd482890', '690896c4513adb4c382ad44c', '6908980e8514aa9990fa0e8a', '692811e032ac5fb2ff474840', '69492cd1350344426c4755b3', '690899b2513adb4c382b0d19',

  '634ff13e255f1c010d4155f9', '671b57acc8f743159078f001', '66fcd06298b7b742ec41e083', '6705ef1b09e252003c28546f', '671f1fa516fdb45aceda3fa6', '675450db240621f4877d2180', '67544fb1849169ae3a70d164', '671f208628fc46769c8d1a59', '674495e37b19df1afdb56507', '671f4a566d78690ec4ae541c', '671f376f6fb261c9f98f8d60', '675452da6c384d83362d4fc1',

  '634fed7142e1ef0011a9e46f', '671b4e1f67963fbeea45ad82', '66fcc1d7ce23618725b46e22', '66fcc32f79e47de0ea84749f', '671f1c9b25bfb2456b4958ee', '67544bc971bd617011445aba', '67544cefdcdf8236d8319f29', '671f1ca10de78f2edda2890e', '6754520a411eeb9897cb7043', '671f1e63e110eaba2743b934', '671f1d526c96227a94a1d26d', '67544a5a14a0fe92bcc75141',

  '634fe9909bda420018289bf5', '65f0261690b7660018356678', '634ff4c28b91980018fa7abb', '663130843495990018f311b9', '66313005a901de001842c5d5', '66312e80834384001884db17',

  '65e82a2ca1b90100187235a6', '6350f2946081950011bc28b5', '65e82967627be00018747e34', '65e821517a81bf001848f016', '65e81dd13fb68000181b24b7', '65e856337a81bf001849b111', '65e84533fc0a5c0018ed4675', '65e844aa854d7c0018c286eb', '65f4989646d7d1001903bb93',

  '665752b16e567c001801b0aa', '66689a820bc1cb0018e1a178'
]
